
import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import Enumerable from "linq";
import { DomainRegistry } from "../../../domain";
import { default as WorkflowListBaseMixin } from "./WorkflowListBaseMixin.vue";
import { ReceptionDetailSearchCondition, ReceptionDetailProgressSearchCondition, ReceptionDetailPresetSearchCondition, ReceptionDetailCsvFilePrint } from "../../../domain/workflow/search";
import { ReceptionDetailListDispInfo } from "../../../domain/workflow/list";
import { WorkflowStatusName, DocumentCreateButtonInfo, ReceptionDetailListItem, ReceptionDetailListColor, ReceptionListCardStyleDispInfo, } from "../../../domain/workflow/items";
import { WorkflowListActionKinds, WorkflowStatusKinds, WorkflowTabVisibleKinds, WorkflowPresetKinds } from "../../../domain/workflow/kinds";
import { Patient } from "../../../domain/patient";
import { Department, DepartmentGroup } from "../../../domain/department";
import { DateDuration } from "../../../domain/system";

import { StandardOption } from "../../system/selectors/mixins";
import { WindowOpener } from "../../system/utilities";
import { DepartmentGroupSelectableMixin } from "../../department/mixins";
import { DateDurationOptionsSource } from "../selectors/options";
import { UrlSchemeClient } from "../../../utilities";

@Component({
})

/**
 * ワークフロー一覧（管理者向け） 画面用Mixin
 */
export default class WorkflowListViewMixin extends Mixins(WorkflowListBaseMixin, DepartmentGroupSelectableMixin) {

  @Prop()
  defaultDepartmentsCondition: Department[];

  @Prop()
  defaultDisplaySetting: ReceptionDetailListDispInfo;

  data(): any {
    return {
      displayKind: WorkflowTabVisibleKinds.All,
      displayWFStatus: null,
      displaySetting: null as ReceptionDetailListDispInfo,
      
      searchCondition: null,
      searchWFConditions: [],

      patientCondition: null,
      departmentsCondition: [],
      isFirstSearch: null,
      sortedPresetKeys: [],
    };
  }
  displayKind: WorkflowTabVisibleKinds;
  displayWFStatus: WorkflowStatusName;
  displaySetting: ReceptionDetailListDispInfo;

  // 検索条件保存用（タブ切替・再検索用）
  searchCondition: ReceptionDetailSearchCondition;
  searchWFConditions: ReceptionDetailProgressSearchCondition[];
  searchPresetConditions: ReceptionDetailPresetSearchCondition[] = [];
  selectedPresetCondition: ReceptionDetailPresetSearchCondition = new ReceptionDetailPresetSearchCondition();
  sortedPresetKeys: string[];

  patientCondition: Patient;
  departmentsCondition: Department[];
  isFirstSearch: boolean;
  selectedPresetOption: ReceptionDetailPresetSearchCondition = null;


  async created() {
    if (this.defaultDisplaySetting) {
      // 起動時やカード・リスト切り替え時、displaySettingがnullのため親で取得した設定で先に描画
      this.displaySetting = this.defaultDisplaySetting;
    }
    // 起動時に初回表示の設定をONにする
    this.isFirstSearch = true;
    if (this.isDepartmentGroupEnable) {
      this.selectedDepartmentGroup = this.storedDepartmentGroup;
    }
    this.sortedPresetKeys = await this.getPresetOrder();
    await this.getDispSetting();
  }

  mounted(): void {
    // $refsはリアクティブではない模様.マウント後に初期化.
    this.departmentsCondition = this.defaultDepartmentsCondition;
  }

  @Emit()
  changeButtonInfo(buttons: DocumentCreateButtonInfo[]): void {}

  @Emit()
  changeNewReceptionButtonEnable(isEnable: boolean): void {}

  @Emit()
  changeDocumentListButtonEnable(isEnable: boolean): void {}

  @Emit()
  changePatientCondition(value: Patient): void {}

  @Emit()
  saveDepartmentsCondition(value: Department[]): void {}

  @Emit()
  generalFlagUpdated(): void {}

  @Emit()
  shouldTakeOverPatientNoFromMainViewUpdated(shouldTakeOverPatientNoFromMainView: boolean): void {}

  @Watch("patientCondition")
  onPatientChanged(newValue: Patient, oldValue: Patient) {
    this.changePatientCondition(newValue);
    
    // if (!newValue) { return; } // 終了・条件無しでもそんなに遅くないので、どういう条件でも再検索かける
    this.refreshSearch(true);
  }

  @Watch("departmentsCondition")
  onDepartmentChanged(newValue: Department[], oldValue: Department[]) {
    // if (!newValue || newValue.length === 0) { return; } // 終了・条件無しでもそんなに遅くないので、どういう条件でも再検索かける
    
    this.refreshSearch(true);
  }

  @Watch("selectedDepartmentGroup")
  onSelectedDepartmentGroupChanged(newValue: DepartmentGroup) {
    this.refreshSearch(true);
  }

  @Watch("shouldTakeOverPatientNoFromMainView")
  onshouldTakeOverPatientNoFromMainViewUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue !== oldValue) {
      this.shouldTakeOverPatientNoFromMainViewUpdated(newValue);
    }
  }

  get isDepartmentGroupConflicted(): boolean {
    return this.departmentsCondition
      && this.selectedDepartmentGroup
      && this.departmentsCondition.some(d => !this.selectedDepartmentGroup.departments.some(g => g.id === d.id));
  }

  get isPresetDepartmentIdSpecified(): boolean {
    return this.selectedPresetCondition
      && this.selectedPresetCondition.condition
      && this.selectedPresetCondition.condition.isDepartmentIdSpecified;
  }

  get shouldTakeOverPatientNoFromMainView(): boolean {
    return this.displaySetting && this.displaySetting.shouldTakeOverPatientNoFromMainView;
  }

  get shouldShowManagerPhoneNumber(): boolean {
    return this.displaySetting && this.displaySetting.shouldShowManagerPhoneNumber;
  }

  get shouldShowCsvDownloadButton(): boolean {
    return this.displaySetting && this.displaySetting.shouldShowCsvDownloadButton;
  }

  get shouldShowListPrintButton(): boolean {
    return this.displaySetting && this.displaySetting.shouldShowListPrintButton;
  }

  // ------------------タブ表示状態--------------------------

  // すべてタブ表示
  showAllTab(): void {
    this.displayKind = WorkflowTabVisibleKinds.All;
  }

  // WF状態タブ表示
  showWorkflowTab(status: WorkflowStatusName): void {
    this.displayKind = WorkflowTabVisibleKinds.Status;
    this.displayWFStatus = status;
  }

  // 完了タブ表示
  showFinishTab(): void {
    this.displayKind = WorkflowTabVisibleKinds.Finish;
    this.displayWFStatus = this.finishStatus;
  }

  // 一時退避タブ表示
  showSuspendTab(): void {
    this.displayKind = WorkflowTabVisibleKinds.Suspend;
    this.displayWFStatus = this.suspendStatus;
  }

  get isAllTabVisible(): boolean {
    return this.displayKind === WorkflowTabVisibleKinds.All;
  }

  get isPresetTabVisible(): boolean {
    return this.displayKind === WorkflowTabVisibleKinds.Preset;
  }

  get searchConditionSummary(): string {
    return this.searchCondition ? this.searchCondition.getSummary(this.generalFlag1LabelName) : "";
  }

  progressConditionSummary(status: WorkflowStatusName): string {
    const condition = this.getWFSearchCondition(status);
    return condition ? condition.getSummary(this.generalFlag1LabelName) : "";
  }

  get searchPresetConditionSummary(): string {
    return this.selectedPresetCondition ? this.selectedPresetCondition.condition.getSummary(this.generalFlag1LabelName) : "";
  }

  isWorkflowTabVisible(status: WorkflowStatusName): boolean {
    return this.displayKind === WorkflowTabVisibleKinds.Status 
      && this.displayWFStatus === status;
  }

  get isFinishTabVisible(): boolean {
    return this.displayKind === WorkflowTabVisibleKinds.Finish;
  }

  get isSuspendTabVisible(): boolean {
    return this.displayKind === WorkflowTabVisibleKinds.Suspend;
  }

  get activeStatuses(): WorkflowStatusName[] {
    const statuses = this.displaySetting ? this.displaySetting.getWorkflowStatuses(WorkflowStatusKinds.Avtive) : [];
    return statuses;
  }

  get finishStatus(): WorkflowStatusName {
    return this.displaySetting ? this.displaySetting.getWorkflowStatuses(WorkflowStatusKinds.Finished)[0] : null;
  }

  get finishStatusName(): string {
    return this.finishStatus ? this.finishStatus.waitName : "";
  }

  get isSuspendStatusEnable(): boolean {
    return this.displaySetting ? this.displaySetting.isSuspendStatusEnable : false;
  }

  get suspendStatus(): WorkflowStatusName {
    return this.displaySetting ? this.displaySetting.getWorkflowStatuses(WorkflowStatusKinds.Suspended)[0] : null;
  }

  get suspendStatusName(): string {
    return this.suspendStatus ? this.suspendStatus.waitName : "";
  }

  get hasParamPatientNo(): boolean {
    return this.paramPatientNo ? true : false;
  }

  get defaultSearchPeriod(): DateDuration {
    return this.displaySetting ? this.displaySetting.defaultSearchPeriod : new DateDuration(null, null);
  }

  get displayListItems(): ReceptionDetailListItem[] {
    return this.displaySetting 
      ? Enumerable.from(this.displaySetting.displayItemList)
          .where(i => i.isEnable)
          .orderBy(i => i.index).toArray()
      : [];
  }

  get cardStyleDisplayInfo(): ReceptionListCardStyleDispInfo {
    return this.displaySetting
      ? this.displaySetting.cardStyle
      : null;
  }

  get doubleClickAction(): WorkflowListActionKinds {
    return this.displaySetting ? this.displaySetting.workflowListDoubleClickAction : WorkflowListActionKinds.EditDetail;
  }

  get displayListColor(): ReceptionDetailListColor {
    return this.displaySetting ? this.displaySetting.displayColor : null;
  }

  get sortedSearchPresetConditions(): ReceptionDetailPresetSearchCondition[] {
    return this.shouldSortPresetByOrderSettings
      ? this.createSortedSearchPresetConditions()
      : this.searchPresetConditions ? Enumerable.from(this.searchPresetConditions).orderBy(c => c.presetKind).thenBy(c => c.index).toArray() : [];
  }

  set sortedSearchPresetConditions(conditions: ReceptionDetailPresetSearchCondition[]) {
    this.sortedPresetKeys = Enumerable.from(conditions).select(c => c.key).toArray();
  }

  get shouldSortPresetByOrderSettings(): boolean {
    return this.sortedPresetKeys
        && (0 < this.sortedPresetKeys.length)
        && Enumerable.from(this.searchPresetConditions ? this.searchPresetConditions : []).any(s => this.sortedPresetKeys.some(k => k === s.key));
  }

  get departmentId(): string {
    return this.$store.getters.department
      ? this.$store.getters.department.id
      : null;
  }

  get isAdministratorDepartment(): boolean {
    return this.departmentId && Enumerable.from(this.$store.getters.userAuthority.administratorDepartmentIds as string[])
      .any(d => d === this.departmentId);
  }

  get isCommonItemEditable(): boolean {
    return this.$store.getters.userAuthority.commonItemEditable;
  }

  get maxDisplayPresetCount(): number {
    // TODO 今後設定化するかも
    return 3;
  }

  get isPresetDropDownEnable(): boolean {
    return (this.maxDisplayPresetCount < this.searchPresetConditions.length);
  }

  get presetOptions(): StandardOption<ReceptionDetailPresetSearchCondition>[] {
    const dropDownConditions = this.isPresetDropDownEnable ? this.sortedSearchPresetConditions.slice(this.maxDisplayPresetCount - 1, this.searchPresetConditions.length) : [];
    return Enumerable.from(dropDownConditions).select(c => new StandardOption<ReceptionDetailPresetSearchCondition>(this.toPresetName(c), c)).toArray();
  }

  isPresetOptionCondition(condition: ReceptionDetailPresetSearchCondition): boolean {
    return this.isPresetDropDownEnable
      && Enumerable.from(this.presetOptions)
        .any(o => o.value && o.value.presetKind === condition.presetKind && o.value.index === condition.index);
  }

  toPresetName(condition: ReceptionDetailPresetSearchCondition): string {
    if (condition.name) { return condition.name; }

    switch (condition.presetKind) {
      case WorkflowPresetKinds.Person: return "個）プリセット" + condition.index;
      case WorkflowPresetKinds.Department: return "診）プリセット" + condition.index;
      case WorkflowPresetKinds.All: return "全）プリセット" + condition.index;
    }
  }

  // -----------------------WF状態別-------------------------

  // 検索条件の状態リスト
  get workflowStatusList(): WorkflowStatusName[] {
    if (!this.displaySetting) { return []; }

    return this.displaySetting.workflowStatuses;
  }

  // 初期選択する進捗コード
  get defaultSelectedStatusCodeList(): number[] {
    if (!this.displaySetting) { return[]; }

    return this.displaySetting.defaultSelectedWorkflowStatusCodeList;
  }

  // 指定のWF状態の保存済み検索条件を取得
  getWFSearchCondition(targetStatus: WorkflowStatusName): ReceptionDetailProgressSearchCondition {
    return Enumerable.from(this.searchWFConditions)
      .where(m => m.workflowStatus.status.code === targetStatus.code)
      .firstOrDefault();
  }

  // WF状態ごとの検索条件を保存（検索時）
  setWFSearchCondition(condition: ReceptionDetailProgressSearchCondition): void {
    const dic = Enumerable.from(this.searchWFConditions).toDictionary(m => m.workflowStatus.status.code);
    dic.remove(condition.workflowStatus.status.code);
    this.searchWFConditions = dic.toEnumerable().select(m => m.value).toArray();
    
    this.searchWFConditions.push(condition);
  }

  // ---------------------Emitで呼ばれる--------------------------------

  // 依頼削除通知を受け取りました
  onDeletedReceptionDetail() {
    this.$logger.debug("onDeletedReceptionDetail");

    this.reference = null;
    this.refreshSearch();
  }

  // WF実行通知を受け取りました
  onDoActionedReceptionDetail() {
    this.$logger.debug("onDoActionedReceptionDetail");

    this.reference = null;
    this.refreshSearch();
  }

  // 依頼詳細検索依頼が届きました
  async onExecDetailSearch(condition: ReceptionDetailSearchCondition, needConfirm: boolean): Promise<void> {
    this.$logger.debug("onExecDetailSearch");
    if (this.needConfirmBeforeSearch(needConfirm)) {
      const index = await this.$commonDialogs.confirmation.confirmExecuteCancel(
        null,
        ["検索に時間がかかる可能性がありますが、実行しますか？"]
      );
      if (index === 0) {
        this.execDetailSearch(condition);
      }
      return;
    }
    
    this.execDetailSearch(condition);
  }

  private execDetailSearch(condition: ReceptionDetailSearchCondition): void {
    this.searchCondition = condition.clone();
    if (this.hasParamPatientNo && this.isFirstSearch) { // 初回のみ
      this.getParamPatientInfo();
    } else {
      if (this.isDepartmentGroupConflicted) {
        this.$logger.debug(this.$wording.common.departmentGroup + "に存在しない" + this.$wording.common.department + "が選択されているため検索を中断します。");
        this.setDetailList([], false);
        return;
      }
      this.searchReceptionDetail(true);
    }
  }

  // 依頼詳細CSV出力依頼が届きました
  onExecDetailOutCsv(condition: ReceptionDetailSearchCondition, shouldPrintCsv: boolean): void {
    this.$logger.debug("onExecDetailOutCsv");
    this.hidePreview();

    this.createCsvReceptionDetail(condition, shouldPrintCsv).then(() => {
      this.showPreview();
    }).catch(() => {
      this.showPreview();
    });
  }

  // 依頼詳細（WF状態）検索依頼が届きました
  async onExecDetailProgressSearch(condition: ReceptionDetailProgressSearchCondition, needConfirm: boolean): Promise<void> {
    this.$logger.debug("onExecDetailProgressSearch");

    if (condition.workflowStatus.status.type === WorkflowStatusKinds.Finished) {
      if (this.needConfirmBeforeSearch(needConfirm)) {
        const index = await this.$commonDialogs.confirmation.confirmYesNo(
          "確認",
          ["検索に時間がかかる可能性がありますが、実行しますか？"]
        );
        if (index === 0) {
          this.execDetailProgressSearch(condition);
        }
        return;
      }
    }

    this.execDetailProgressSearch(condition);
  }

  private execDetailProgressSearch(condition: ReceptionDetailProgressSearchCondition): void {
    const clonedCondition = condition.clone();
    this.setWFSearchCondition(clonedCondition);
    if (this.isDepartmentGroupConflicted) {
      this.$logger.debug(this.$wording.common.departmentGroup + "に存在しない" + this.$wording.common.department + "が選択されているため検索を中断します。");
      this.setDetailList([], false);
      return;
    }
    this.searchReceptionDetailProgress(clonedCondition, true);
  }

  // 依頼詳細（WF状態）CSV出力依頼が届きました
  onExecDetailProgressOutCsv(condition: ReceptionDetailProgressSearchCondition, shouldPrintCsv: boolean): void {
    this.$logger.debug("onExecDetailProgressOutCsv");
    this.hidePreview();

    this.createCsvReceptionDetailProgress(condition, shouldPrintCsv).then(() => {
      this.showPreview();
    }).catch(() => {
      this.showPreview();
    });
  }

  // 依頼詳細（プリセット）検索依頼が届きました
  async onExecDetailPresetSearch(condition: ReceptionDetailSearchCondition, needConfirm: boolean): Promise<void> {
    this.$logger.debug("onExecDetailPresetSearch");
    if (this.needConfirmBeforeSearch(needConfirm)) {
      const index = await this.$commonDialogs.confirmation.confirmExecuteCancel(
        null,
        ["検索に時間がかかる可能性がありますが、実行しますか？"]
      );
      if (index === 0) {
        this.execDetailPresetSearch(condition);
      }

      return;
    }
    
    this.execDetailPresetSearch(condition);
  }

  private execDetailPresetSearch(condition: ReceptionDetailSearchCondition): void {
    const defaultSelectedPreset = Enumerable.from(this.searchPresetConditions)
      .where(p => p.isDefaultSelected)
      .orderBy(p => p.presetKind)
      .firstOrDefault();
    if (defaultSelectedPreset && this.isFirstSearch) {
      // 初回選択されたプリセットがドロップダウンに存在する場合、ドロップダウンを選択状態にする
      if (this.isPresetOptionCondition(defaultSelectedPreset)) {
        this.selectedPresetOption = defaultSelectedPreset;
      }
      this.selectedPresetCondition = defaultSelectedPreset.clone();
      // 期間のキー名称から実際の期間を復旧させている（通常の検索時はコンポーネント側で復旧させている）
      const duration = DateDurationOptionsSource.getPastDurationByName(defaultSelectedPreset.condition.durationPickerKey);
      if (duration) {
        this.selectedPresetCondition.condition.duration = duration;
      }
      const limitDate = DateDurationOptionsSource.getFutureDurationByName(defaultSelectedPreset.condition.limitDatePickerKey);
      if (limitDate) {
        this.selectedPresetCondition.condition.limitDate = limitDate;
      }
    } else {
      this.selectedPresetCondition.condition = condition.clone();
    }
    if (this.hasParamPatientNo && this.isFirstSearch) { // 初回のみ
      this.getParamPatientInfo();
    } else {
      if (!this.isPresetDepartmentIdSpecified && this.isDepartmentGroupConflicted) {
        this.$logger.debug(this.$wording.common.departmentGroup + "に存在しない" + this.$wording.common.department + "が選択されているため検索を中断します。");
        this.setDetailList([], false);
        return;
      }
      this.searchReceptionDetailPreset(true);
    }
  }

  // 依頼詳細（プリセット）CSV出力依頼が届きました
  onExecDetailPresetOutCsv(condition: ReceptionDetailSearchCondition, shouldPrintCsv: boolean): void {
    this.$logger.debug("onExecDetailOutCsv");
    this.hidePreview();

    this.createCsvReceptionDetailPreset(condition, shouldPrintCsv).then(() => {
      this.showPreview();
    }).catch(() => {
      this.showPreview();
    });
  }

  private needConfirmBeforeSearch(needConfirm: boolean): boolean {
    // 患者未指定の場合は確認要
    return needConfirm && !this.patientCondition;
  }

  // 依頼書削除通知を受け取りました
  onRequestSheetDeleted(): void {
    this.$logger.debug("onRequestSheetDeleted");
    this.reloadDetail();
  }

  // プリセット登録
  async onExecSavePreset(preset: ReceptionDetailPresetSearchCondition): Promise<string> {
    this.selectedPresetCondition.condition = preset.condition.clone();
    this.selectedPresetCondition.name = preset.name;
    this.selectedPresetCondition.isDefaultSelected = preset.isDefaultSelected;
    this.selectedPresetCondition.isStatusTabEnabled = preset.isStatusTabEnabled;
    // プリセット患者、診療科情報更新
    preset.condition.patient = preset.condition.presetPatient;
    preset.condition.departments = preset.condition.presetDepartments;

    // 保持しているプリセット情報を更新（プリセットとして登録しない条件はリセット）
    const saveCondition = preset.condition.clone();
    saveCondition.duration = new DateDuration(null, null);
    saveCondition.limitDate = new DateDuration(null, null);
    const updateTarget = Enumerable.from(this.searchPresetConditions).first(c => (c.presetKind === preset.presetKind) && (c.index === preset.index));
    const updateTargetIndex = Enumerable.from(this.searchPresetConditions).indexOf(s => (s.presetKind === preset.presetKind) && (s.index === preset.index));
    if (updateTarget) {
      updateTarget.condition = saveCondition;
      updateTarget.name = preset.name;
      updateTarget.isDefaultSelected = preset.isDefaultSelected;
      updateTarget.isStatusTabEnabled = preset.isStatusTabEnabled;
    }

    // save後に再取得していないため初回選択されていたら他のプリセットの初回選択をクリア
    if (preset.isDefaultSelected) {
      Enumerable.from(this.searchPresetConditions)
      .where(c => (c.presetKind === preset.presetKind) && (c.index !== preset.index))
      .forEach(c => {
        c.isDefaultSelected = false;
      });
    }

    const key = await this.savePresetCondition();
    if (key) {
      updateTarget.key = key;
      this.selectedPresetCondition.key = key;
    }
    this.searchPresetConditions.splice(updateTargetIndex, 1, updateTarget);
    return key;
  }

  // 子どもから汎用フラグ更新通知がきました
  onGeneralFlagUpdated(): void {
    this.$logger.debug("onGeneralFlagUpdated");
    this.refreshSearch();
  }

  // --------------------メソッド（$refでも呼ばれる）---------------------------------

  // 再検索
  refreshSearch(shouldSelectFirst: boolean = false): void {
    this.$logger.debug("exec refreshSearch..");
    if (this.isDepartmentGroupConflicted) {
      this.$logger.debug(this.$wording.common.departmentGroup + "に存在しない" + this.$wording.common.department + "が選択されているため検索を中断します。");
      this.setDetailList([], false);
      return;
    }

    // すべてタブ選択状態か
    if (this.isAllTabVisible) {
      this.searchReceptionDetail(shouldSelectFirst);
      return;
    } else if (this.isPresetTabVisible) {
      this.searchReceptionDetailPreset(shouldSelectFirst);
      return;
    }

    // 進捗タブ
    const condition = this.getWFSearchCondition(this.displayWFStatus);
    if (!condition) {
      // 無いかも
      console.log("refreshSearch. wfStatusCondition is nothing.");
      return;
    }
    this.searchReceptionDetailProgress(condition, shouldSelectFirst);
    return;
  }

  // --------------------API通信-----------------------------------

  // 表示設定取得
  async getDispSetting(): Promise<void> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      this.isLoading = true;
      const result = await repository.getReceptionDetailListInitSetting();
      const presetConditions = await repository.getPresetCondition(this.departmentId);
      this.isLoading = false;

      this.$logger.debug("displaySetting is set.");
      this.displaySetting = result;
      this.changeButtonInfo(this.displaySetting ? this.displaySetting.documentCreateButtons : []);
      this.changeNewReceptionButtonEnable(this.displaySetting ? this.displaySetting.isNewReceptionButtonEnable : true);
      this.changeDocumentListButtonEnable(this.displaySetting ? this.displaySetting.isDocumentListButtonEnable : true);
      this.changeManagerHistorySearchEnable(this.displaySetting ? this.displaySetting.isManagerHistorySearchEnable : false);

      this.searchPresetConditions = presetConditions;
      this.displayKind = Enumerable.from(this.searchPresetConditions).any(c => c.isDefaultSelected)
        ? WorkflowTabVisibleKinds.Preset
        : WorkflowTabVisibleKinds.All;
    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "表示設定の取得に失敗しました。", e);
    }
  }

  // パラメータで指定された患者情報を取得
  async getParamPatientInfo(): Promise<void> {
    if (!this.paramPatientNo) { return; }
    try {
      const repository = DomainRegistry.patient.getPatientRepository();
      this.isLoading = true;
      const result = await repository.getEntity(this.paramPatientNo);
      this.isLoading = false;
  
      this.$logger.debug("param patient is set.");
      this.patientCondition = result;
    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "指定患者の取得に失敗しました。", e);
    }
  }

  // 依頼詳細検索
  async searchReceptionDetail(shouldSelectFirst: boolean): Promise<void> {
    if (!this.searchCondition) {
      this.$logger.debug("searchConditionがまだ設定されていないので依頼詳細検索を中断します。");
      return;
    }

    try {
      // 患者と診療科をセット
      this.searchCondition.patient = this.patientCondition;
      this.searchCondition.isDepartmentGroupSpecified = !!this.selectedDepartmentGroup;
      this.searchCondition.departments = this.departmentsCondition;
      const condition = this.searchCondition.clone();
      condition.departments = this.departmentSearchCondition;

      this.clearSearchResult();
    
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      this.isLoading = true;
      const result = await repository.searchReceptionDetail(condition);
      this.overLimitMessage = result.overLimitMessage;
      this.setDetailList(result.list, shouldSelectFirst);
      this.isLoading = false;

    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "ワークフロー一覧の取得に失敗しました。", e);
    }
  }

  get departmentSearchCondition(): Department[] {
    return this.departmentsCondition && this.departmentsCondition.length > 0
      ? this.departmentsCondition
      : this.selectedDepartmentGroup
        ? this.selectedDepartmentGroup.departments
        : [];
  }

  // 依頼詳細CSV出力
  async createCsvReceptionDetail(condition: ReceptionDetailSearchCondition, shouldPrintCsv: boolean): Promise<void> {
    try {

      // 患者と診療科をセット
      condition.patient = this.patientCondition;
      condition.isDepartmentGroupSpecified = !!this.selectedDepartmentGroup;
      condition.departments = this.departmentsCondition;
      const searchCondition = condition.clone();
      searchCondition.departments = this.departmentSearchCondition;

      const repository = DomainRegistry.workflow.getWorkflowRepository();
      this.isLoading = true;
      const result = await repository.createCsvReceptionDetail(searchCondition);
      this.isLoading = false;
      this.downloadCsvFile(result, shouldPrintCsv);
    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "ワークフロー一覧のCSV出力に失敗しました。", e);
    }
  }

  private downloadCsvFile(csvFile: ReceptionDetailCsvFilePrint, shouldPrintCsv: boolean): void {
    if (csvFile && csvFile.downloadUrl) {
      if (shouldPrintCsv) {
        this.printCsvFile(csvFile.downloadUrl);
      } else {
        this.downloadFile(csvFile.downloadUrl);
      }
      if (csvFile.overLimitMessage) {
        this.$warn("CSV出力", csvFile.overLimitMessage);
      }
    }
  }

  // 依頼詳細（WF状態別）検索
  async searchReceptionDetailProgress(condition: ReceptionDetailProgressSearchCondition, shouldSelectFirst: boolean): Promise<void> {
    try {
      // 患者と診療科をセット
      condition.patient = this.patientCondition;
      condition.isDepartmentGroupSpecified = !!this.selectedDepartmentGroup;
      condition.departments = this.departmentsCondition;
      const searchCondition = condition.clone();
      searchCondition.departments = this.departmentSearchCondition;

      this.clearSearchResult();

      const repository = DomainRegistry.workflow.getWorkflowRepository();
      this.isLoading = true;
      const result = await repository.searchReceptionDetailProgress(searchCondition);
      this.overLimitMessage = result.overLimitMessage;
      this.setDetailList(result.list, shouldSelectFirst);
      this.isLoading = false;

    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "ワークフロー一覧の取得に失敗しました。", e);
    }
  }

  // 依頼詳細（WF状態別）検索
  async createCsvReceptionDetailProgress(condition: ReceptionDetailProgressSearchCondition, shouldPrintCsv: boolean): Promise<void> {
    try {

      // 患者と診療科をセット
      condition.patient = this.patientCondition;
      condition.isDepartmentGroupSpecified = !!this.selectedDepartmentGroup;
      condition.departments = this.departmentsCondition;
      const searchCondition = condition.clone();
      searchCondition.departments = this.departmentSearchCondition;

      const repository = DomainRegistry.workflow.getWorkflowRepository();
      this.isLoading = true;
      const result = await repository.createCsvReceptionDetailProgress(searchCondition);
      this.isLoading = false;
      this.downloadCsvFile(result, shouldPrintCsv);
    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "ワークフロー一覧のCSV出力に失敗しました。", e);
    }
  }

  // 依頼詳細（プリセット）検索
  async searchReceptionDetailPreset(shouldSelectFirst: boolean): Promise<void> {
    try {
      // 患者と診療科をセット
      this.selectedPresetCondition.condition.patient = this.patientCondition;
      this.selectedPresetCondition.condition.isDepartmentGroupSpecified = (!this.isPresetDepartmentIdSpecified && !!this.selectedDepartmentGroup);
      this.selectedPresetCondition.condition.departments = this.departmentsCondition;
      const searchCondition = this.selectedPresetCondition.condition.clone();
      searchCondition.departments = this.departmentSearchCondition;
      this.clearSearchResult();

      const repository = DomainRegistry.workflow.getWorkflowRepository();
      this.isLoading = true;
      const result = await repository.searchReceptionDetailPreset(searchCondition);
      this.overLimitMessage = result.overLimitMessage;
      this.setDetailList(result.list, shouldSelectFirst);
      this.isLoading = false;

    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "ワークフロー一覧の取得に失敗しました。", e);
    }
  }
  // 依頼詳細（プリセット）CSV出力
  async createCsvReceptionDetailPreset(condition: ReceptionDetailSearchCondition, shouldPrintCsv: boolean): Promise<void> {
    try {
      // 患者と診療科をセット
      condition.patient = this.patientCondition;
      condition.isDepartmentGroupSpecified = !!this.selectedDepartmentGroup;
      condition.departments = this.departmentsCondition;
      const searchCondition = condition.clone();
      searchCondition.departments = this.departmentSearchCondition;

      const repository = DomainRegistry.workflow.getWorkflowRepository();
      this.isLoading = true;
      const result = await repository.createCsvReceptionDetailPreset(searchCondition);
      this.isLoading = false;
      this.downloadCsvFile(result, shouldPrintCsv);
    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "ワークフロー一覧のCSV出力に失敗しました。", e);
    }
  }

  // プリセット情報の取得
  async getPresetCondition(): Promise<ReceptionDetailPresetSearchCondition[]> {
    try {
      // isLoadingは使う側のほうで変更を行う！！！
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      const presetConditions = await repository.getPresetCondition(this.departmentId);

      return presetConditions;
    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "ワークフロー検索プリセットの取得に失敗しました", e);
    }
  }

  // プリセット情報を登録
  async savePresetCondition(): Promise<string> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      this.isLoading = true;
      const key = await repository.registerPresetCondition(this.selectedPresetCondition);
      this.isLoading = false;

      return key;
    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "ワークフロー検索プリセットの登録に失敗しました。", e);
    }
  }

  // プリセット情報を削除
  async deletePresetCondition(): Promise<void> {
    try {
      // isLoadingは使う側のほうで変更を行う！！！
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      await repository.deletePresetCondition(this.selectedPresetCondition);

    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "ワークフロー検索プリセットの登録に失敗しました。", e);
    }
  }

  async getPresetOrder(): Promise<string[]> {
    try {
      return DomainRegistry.workflow.getWorkflowRepository().getPresetOrder();
    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "ワークフロー検索プリセットの並び順取得に失敗しました", e);
    }
  }

  createSortedSearchPresetConditions(): ReceptionDetailPresetSearchCondition[] {
    if (!this.searchPresetConditions) { return []; }
    // 並び順
    // 並び順未登録の個人プリセットのindex降順 + 並び順登録済みプリセットのindex昇順 + 並び順未登録の診療科プリセットのindex降順 + 並び順未登録の全科プリセットのindex降順
    const orderUnspecifiedConditions = Enumerable.from(this.searchPresetConditions)
      .where(c => !!c && (!c.key || this.sortedPresetKeys.every(k => k !== c.key)))
      .orderByDescending(c => c.index)
      .groupBy(c => c.presetKind);
    const orderSpecifiedConditions = Enumerable.from(this.sortedPresetKeys)
      .select(k => Enumerable.from(this.searchPresetConditions).firstOrDefault(c => c.key === k))
      .where(c => !!c)
      .toArray();
    return this.toArrayOrEmpty(orderUnspecifiedConditions.firstOrDefault(g => g.key() === WorkflowPresetKinds.Person))
      .concat(orderSpecifiedConditions)
      .concat(this.toArrayOrEmpty(orderUnspecifiedConditions.firstOrDefault(g => g.key() === WorkflowPresetKinds.Department)))
      .concat(this.toArrayOrEmpty(orderUnspecifiedConditions.firstOrDefault(g => g.key() === WorkflowPresetKinds.All)));
  }

  private toArrayOrEmpty<T>(source: Enumerable.IEnumerable<T>): T[] {
    return source
      ? source.toArray()
      : [];
  }

  // ページ遷移せずにダウンロード通知バーを表示させる
  private downloadFile(url: string): void {
    window.location.href = WindowOpener.toUrl(url, {});
  }

  private printCsvFile(sourceUrl: string): void {
    const url = this.$configuration.behavior.localhost.schemeUrlPrefix
      + "?action=printWorkflowList"
      + "&source=" + this.toAsciiText(sourceUrl);
    const client = new UrlSchemeClient();
    client.request(url);
  }

  /**
   * 記号を含まない16進数範囲の文字に変換している
   */
  private toAsciiText(source: string): string {
    return encodeURIComponent(source).split("").map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("-");
  }
}
